export const PERMISSIONS = Object.freeze({
  MAILBOX_VIEW: "mailbox.view",
  MAILBOX_SEND: "mailbox.send",
  MAILBOX_MODIFY: "mailbox.modify",
  DASHBOARD_VIEW: "dashboard.view",
  SALES_VIEW: "sales_pipeline.view",
  SALES_VIEW_ALL_QUERIES: "sales_pipeline.view_all_queries",
  SALES_VIEW_AGENT_CHAT_OVERVIEW: "sales_pipeline.view_agent_chat_overview",
  SALES_PIPELINE_VIEW_PAYMENTS: "sales_pipeline.view_payments",
  SALES_PIPELINE_CREATE_PAYMENT_LINK: "sales_pipeline.create_payment_link",
  SALES_PIPELINE_RECORD_PAYMENT: "sales_pipeline.record_payment",
  SALES_PIPELINE_REVERSE_PAYMENT: "sales_pipeline.reverse_payment",
  PAYMENTS_VIEW: "payments.view",
  PAYMENTS_LOCK_INVOICE: "payments.lock_invoice",
  PAYMENTS_CREATE_LINK: "payments.create_link",
  PAYMENTS_RECORD_CASH: "payments.record_cash",
  PAYMENTS_REPORT_BANK_TRANSFER: "payments.report_bank_transfer",
  PAYMENTS_VERIFY_BANK_TRANSFER: "payments.verify_bank_transfer",
  PAYMENTS_MANAGE_SETTLEMENTS: "payments.manage_settlements",
  PAYMENTS_REQUEST_SETTLEMENT_CHANGES: "payments.request_settlement_changes",
  PAYMENTS_RESOLVE_SETTLEMENT_CHANGES: "payments.resolve_settlement_changes",
  PAYMENTS_MANAGE_CHEQUES: "payments.manage_cheques",
  PAYMENTS_RECORD_ASSIGNED_CHEQUE: "payments.record_assigned_cheque",
  PAYMENTS_RECORD_ASSIGNED_POS: "payments.record_assigned_pos",
  PAYMENTS_RECORD_ASSIGNED_CASH: "payments.record_assigned_cash",
  PAYMENTS_RECONCILE_POS: "payments.reconcile_pos",
  PAYMENTS_RECONCILE_CASH: "payments.reconcile_cash",
  PAYMENTS_REVERSE_RECEIPTS: "payments.reverse_receipts",
  PAYMENTS_MANAGE_REFUNDS: "payments.manage_refunds",
  PAYMENTS_EXCEPTIONAL_RECONCILE: "payments.exceptional_reconcile",
  PAYMENTS_VIEW_ACCOUNTS_WORKSPACE: "payments.view_accounts_workspace",
  LEGACY_SALES_VIEW: "legacy_sales.view",
  OPERATIONS_VIEW: "operations.view",
  OPERATIONS_FIELD_SHIFT: "operations.field_shift",
  OPERATIONS_VIEW_FIELD_LOCATIONS: "operations.view_field_locations",
  OPERATIONS_RECORD_SUPPLIER_OUTCOME: "operations.record_supplier_outcome",
  OPERATIONS_RECORD_ACQUISITION: "operations.record_acquisition",
  OPERATIONS_EXECUTE_LOGISTICS: "operations.execute_logistics",
  OPERATIONS_MANAGE_CANCELLATIONS: "operations.manage_cancellations",
  OPERATIONS_LOCATIONS_MANAGE: "settings.operations_locations.manage",
  SUPPLIER_CHATS_VIEW: "supplier_chats.view",
  SUPPLIERS_VIEW: "suppliers.view",
  USERS_VIEW: "users.view",
  USER_APPROVALS_VIEW: "users.approvals.view",
  REPORTS_VIEW: "reports.view",
  REPORTS_OVERVIEW_VIEW: "reports.overview.view",
  PRICE_SEARCH_VIEW: "price_search.view",
  CUSTOMERS_VIEW: "customers.view",
  AI_ASSISTANT_VIEW: "ai_assistant.view",
  AI_ASSISTANT_MANAGE_CONFIGURATION: "ai_assistant.manage_configuration",
  WATI_DIAGNOSTICS_VIEW: "diagnostics.wati.view",
  DEVELOPER_TOOLS_VIEW: "developer_tools.view",
  SETTINGS_VIEW: "settings.view",
  ACCESS_PRESETS_MANAGE: "settings.access_presets.manage",
  SERVICE_ACCOUNTS_MANAGE: "settings.service_accounts.manage",
  APPROVALS_VIEW: "approvals.view",
  APPROVALS_DECIDE: "approvals.decide",
  APPROVALS_APPLY: "approvals.apply_approved_operation",
  INTERNAL_CHAT_USE: "internal_chat.use",
});

export const PAGE_ROUTES = Object.freeze([
  { key: 'internal-chat', path: '/internal-chat', label: 'Internal Chat', permission: PERMISSIONS.INTERNAL_CHAT_USE },
  { key: "sales", path: "/querysetv4", aliases: ["/"], label: "Sales Pipeline", permission: PERMISSIONS.SALES_VIEW, nav: true },
  { key: "agent-chats", parentKey: "sales", path: "/querysetv4/active-chats", label: "Active Chats by Agent", permission: PERMISSIONS.SALES_VIEW_AGENT_CHAT_OVERVIEW },
  { key: "mail", path: "/mail", matchPrefix: true, label: "Mail", permission: PERMISSIONS.MAILBOX_VIEW, nav: true },
  { key: "dashboard", path: "/dashboard", label: "Dashboard", permission: PERMISSIONS.DASHBOARD_VIEW, nav: true },
  { key: "operations", path: "/operations-v2", matchPrefix: true, label: "Operations V2", permission: PERMISSIONS.OPERATIONS_VIEW, nav: true },
  { key: "my-purchases", path: "/my-purchases", label: "My Purchases", permission: PERMISSIONS.OPERATIONS_RECORD_SUPPLIER_OUTCOME, nav: true },
  { key: "my-deliveries", path: "/my-deliveries", label: "My Pickups & Deliveries", permission: PERMISSIONS.OPERATIONS_EXECUTE_LOGISTICS, nav: true },
  { key: "accounts", path: "/payments/accounts", label: "Accounts", permission: PERMISSIONS.PAYMENTS_VIEW_ACCOUNTS_WORKSPACE, nav: true },
  { key: "ai", path: "/ai_assistant", label: "AI Assistant", permission: PERMISSIONS.AI_ASSISTANT_VIEW, nav: true },
  { key: "suppliers", path: "/suppliers", label: "Suppliers", permission: PERMISSIONS.SUPPLIERS_VIEW, nav: true },
  { key: "users", path: "/hrm", label: "HRM", permission: PERMISSIONS.USERS_VIEW, nav: true },
  { key: "access-management", path: "/settings/access/presets", label: "Access Management", permission: PERMISSIONS.ACCESS_PRESETS_MANAGE, nav: false },
  { key: "reports", path: "/reports", label: "Reports", permission: PERMISSIONS.REPORTS_VIEW, nav: true },
  { key: "reports-overview", path: "/reports/overview", label: "Overview Report", permission: PERMISSIONS.REPORTS_OVERVIEW_VIEW },
  { key: "price-search", path: "/price-search", aliases: ["/search_results"], label: "Price Search", permission: PERMISSIONS.PRICE_SEARCH_VIEW, nav: true },
  { key: "customers", path: "/customers", label: "Customers", permission: PERMISSIONS.CUSTOMERS_VIEW, nav: true },
  { key: "account-approvals", path: "/users", label: "Pending User Accounts", permission: PERMISSIONS.USER_APPROVALS_VIEW },
  { key: "wati-diagnostics", path: "/whatsapp", label: "WATI Status", permission: PERMISSIONS.WATI_DIAGNOSTICS_VIEW },
  { key: "developer-tools", path: "/views-preview", label: "Views Preview", permission: PERMISSIONS.DEVELOPER_TOOLS_VIEW },
]);

export const firstAccessiblePath = can => PAGE_ROUTES.find(route => route.nav && can(route.permission))?.path || "/access-denied";
